import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,{staticClass:"fill-height",attrs:{"no-gutters":"","align":"center"}},[_c(VCol,{attrs:{"align":"center"}},[_c(VProgressCircular,{attrs:{"size":70,"width":7,"color":"primary","indeterminate":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }